package org.solyton.solawi.bid.module.user.`data`.profile

import kotlin.String
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.user.`data`.address.Address
import org.solyton.solawi.bid.module.values.UserId

/**
 * Autogenerated ReadOnly Lens.
 * Read [UserProfile.userId]
 */
@ReadOnly
public val userId: Lens<UserProfile, UserId> by lazy {
      Lens(
        get = { whole -> whole.userId },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [UserProfile.userProfileId]
 */
@ReadOnly
public val userProfileId: Lens<UserProfile, String> by lazy {
      Lens(
        get = { whole -> whole.userProfileId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [UserProfile.firstname]
 */
@ReadWrite
public val firstname: Lens<UserProfile, String> by lazy {
      Lens(
        get = { whole -> whole.firstname },
        set = { part -> { whole -> whole.copy(firstname = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserProfile.firstname]
 */
@ReadWrite
public fun UserProfile.firstname(`set`: String.() -> String): UserProfile = copy(firstname =
    set(firstname))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserProfile.lastname]
 */
@ReadWrite
public val lastname: Lens<UserProfile, String> by lazy {
      Lens(
        get = { whole -> whole.lastname },
        set = { part -> { whole -> whole.copy(lastname = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserProfile.lastname]
 */
@ReadWrite
public fun UserProfile.lastname(`set`: String.() -> String): UserProfile = copy(lastname =
    set(lastname))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserProfile.title]
 */
@ReadWrite
public val title: Lens<UserProfile, String?> by lazy {
      Lens(
        get = { whole -> whole.title },
        set = { part -> { whole -> whole.copy(title = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserProfile.title]
 */
@ReadWrite
public fun UserProfile.title(`set`: String?.() -> String?): UserProfile = copy(title = set(title))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserProfile.phoneNumber]
 */
@ReadWrite
public val phoneNumber: Lens<UserProfile, String?> by lazy {
      Lens(
        get = { whole -> whole.phoneNumber },
        set = { part -> { whole -> whole.copy(phoneNumber = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserProfile.phoneNumber]
 */
@ReadWrite
public fun UserProfile.phoneNumber(`set`: String?.() -> String?): UserProfile = copy(phoneNumber =
    set(phoneNumber))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserProfile.phoneNumber1]
 */
@ReadWrite
public val phoneNumber1: Lens<UserProfile, String?> by lazy {
      Lens(
        get = { whole -> whole.phoneNumber1 },
        set = { part -> { whole -> whole.copy(phoneNumber1 = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserProfile.phoneNumber1]
 */
@ReadWrite
public fun UserProfile.phoneNumber1(`set`: String?.() -> String?): UserProfile = copy(phoneNumber1 =
    set(phoneNumber1))

/**
 * Autogenerated Lens.
 * Read and manipulate [UserProfile.addresses]
 */
@ReadWrite
public val addresses: Lens<UserProfile, List<Address>> by lazy {
      Lens(
        get = { whole -> whole.addresses },
        set = { part -> { whole -> whole.copy(addresses = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UserProfile.addresses]
 */
@ReadWrite
public fun UserProfile.addresses(`set`: List<Address>.() -> List<Address>): UserProfile =
    copy(addresses = set(addresses))
